/**
 * English translations (Base Language)
 */
const en = {
  // === Common UI ===
  ok: 'OK',
  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  retry: 'Retry',
  back: 'Back',
  settings: 'Settings',
  language: 'Language',

  // === Game Common ===
  score: 'Score',
  level: 'Level',
  game_over: 'Game Over',
  restart: 'Restart',
  pause: 'Paused',
  resume: 'Resume',

  // === Settings ===
  settings_sound: 'Sound',
  settings_music: 'Music',
  settings_reset: 'Reset Game',
  settings_reset_confirm: 'Reset all progress?',

  // === Ads ===
  ad_watch: 'Watch Ad',
  ad_reward: 'Free Reward',
  ad_loading: 'Loading ad...',
  ad_reward_received: 'Reward received!',
  ad_not_completed: 'Ad not completed',

  // === Offline ===
  offline_title: 'Welcome Back!',
  offline_earned: 'You earned while away',

  // === Game HUD ===
  sp: 'SP',
  fame: 'Fame',
  building_tab: 'Building',
  ghosts_tab: 'Ghosts',
  shop_tab: 'Shop',
  prestige_tab: 'Prestige',

  // === New tabs ===
  training_tab: 'Training',
  facilities_tab: 'Extras',
  reviews_tab: 'Reviews',
  menu_tab: 'Menu',

  // === Building ===
  floor_label: 'Floor {n}',
  buy_floor: 'Buy Floor',
  buy_floor_cost: 'Buy Floor ({sp} SP)',
  unlock_slot: 'Unlock Slot',
  unlock_slot_cost: 'Unlock Slot ({sp} SP)',
  build_room: 'Build Room',
  upgrade_room: 'Upgrade Room',
  upgrade_room_cost: 'Upgrade ({sp} SP)',
  room_empty: 'Empty',
  room_locked: 'Locked',
  no_ghost: 'No Ghost',
  assign_ghost: 'Assign Ghost',
  visitors_floor: 'Visitors on this floor',
  add_floor: 'Add Floor',
  add_floor_cost: '+ New Floor ({sp} SP)',

  // === Room Types ===
  room_dark_corridor: 'Dark Corridor',
  room_dark_corridor_desc: 'Psychological fear bonus +30%',
  room_mirror_room: 'Mirror Room',
  room_mirror_room_desc: 'Visual +25%, Psychological +15%',
  room_dungeon: 'Dungeon',
  room_dungeon_desc: 'Psychological +20%, Physical +20%',
  room_graveyard: 'Graveyard Room',
  room_graveyard_desc: 'Psychological fear bonus +40%',
  room_lab: 'Laboratory',
  room_lab_desc: 'Visual +30%, Physical +20%',
  room_library: 'Library',
  room_library_desc: 'Psychological +35%, Auditory +15%',
  room_coffin_room: 'Coffin Room',
  room_coffin_room_desc: 'Visual +30%, Psychological +20%',
  room_doll_room: 'Doll Room',
  room_doll_room_desc: 'Visual +20%, Psychological +35%',
  room_kitchen: 'Cursed Kitchen',
  room_kitchen_desc: 'Physical +30%, Auditory +20%',
  room_bathroom: 'Haunted Bathroom',
  room_bathroom_desc: 'Psychological +30%, Auditory +25%',

  // === New Rooms ===
  room_funhouse: 'Funhouse',
  room_funhouse_desc: 'Visual +35%, Psychological +20%',
  room_trapeze_room: 'Trapeze Room',
  room_trapeze_room_desc: 'Physical +30%, Visual +15%',
  room_freak_show: 'Freak Show',
  room_freak_show_desc: 'Visual +40%, Psychological +30%',
  room_sacrifice_altar: 'Sacrifice Altar',
  room_sacrifice_altar_desc: 'Psychological +40%, Visual +20%',
  room_treasure_vault: 'Treasure Vault',
  room_treasure_vault_desc: 'Psychological +20%, Auditory +20%',
  room_underground_river: 'Underground River',
  room_underground_river_desc: 'Auditory +30%, Psychological +20%',
  room_curse_chamber: 'Curse Chamber',
  room_curse_chamber_desc: 'Psychological +45%, Physical +15%',
  room_mummy_tomb: 'Mummy Tomb',
  room_mummy_tomb_desc: 'Visual +30%, Psychological +30%',
  room_captain_cabin: "Captain's Cabin",
  room_captain_cabin_desc: 'Psychological +30%, Visual +20%',
  room_cargo_hold: 'Cargo Hold',
  room_cargo_hold_desc: 'Physical +25%, Auditory +20%',
  room_davy_jones_locker: "Davy Jones' Locker",
  room_davy_jones_locker_desc: 'Psychological +35%, Visual +25%',
  room_brig: 'Brig',
  room_brig_desc: 'Physical +30%, Psychological +20%',
  room_crows_nest: "Crow's Nest",
  room_crows_nest_desc: 'Physical +35%, Visual +20%',
  room_mine_shaft: 'Mine Shaft',
  room_mine_shaft_desc: 'Physical +30%, Auditory +20%',
  room_crystal_cave: 'Crystal Cave',
  room_crystal_cave_desc: 'Visual +35%, Auditory +15%',
  room_explosives_storage: 'Explosives Storage',
  room_explosives_storage_desc: 'Physical +40%, Auditory +25%',
  room_underground_lake: 'Underground Lake',
  room_underground_lake_desc: 'Psychological +30%, Auditory +25%',
  room_rail_tunnel: 'Rail Tunnel',
  room_rail_tunnel_desc: 'Physical +30%, Psychological +20%',
  room_throne_room: 'Throne Room',
  room_throne_room_desc: 'Visual +25%, Psychological +30%',
  room_wine_cellar: 'Wine Cellar',
  room_wine_cellar_desc: 'Psychological +30%, Visual +15%',
  room_tower_chamber: 'Tower Chamber',
  room_tower_chamber_desc: 'Psychological +35%, Physical +20%',
  room_server_room: 'Server Room',
  room_server_room_desc: 'Auditory +30%, Visual +20%',
  room_quarantine_zone: 'Quarantine Zone',
  room_quarantine_zone_desc: 'Psychological +35%, Physical +20%',
  room_armory: 'Armory',
  room_armory_desc: 'Physical +35%, Visual +20%',
  room_witch_hut: 'Witch Hut',
  room_witch_hut_desc: 'Visual +30%, Psychological +25%',
  room_treehouse: 'Treehouse',
  room_treehouse_desc: 'Physical +25%, Auditory +20%',
  room_swamp_path: 'Swamp Path',
  room_swamp_path_desc: 'Psychological +30%, Auditory +20%',
  room_fairy_ring: 'Fairy Ring',
  room_fairy_ring_desc: 'Psychological +40%, Visual +20%',
  room_ancient_ruin: 'Ancient Ruin',
  room_ancient_ruin_desc: 'Psychological +35%, Visual +25%',
  room_attic: 'Attic',
  room_attic_desc: 'Psychological +30%, Auditory +15%',
  room_secret_passage: 'Secret Passage',
  room_secret_passage_desc: 'Psychological +35%, Physical +15%',
  room_morgue: 'Morgue',
  room_morgue_desc: 'Visual +30%, Psychological +30%',
  room_surgery_room: 'Surgery Room',
  room_surgery_room_desc: 'Physical +35%, Visual +25%',
  room_music_room: 'Music Room',
  room_music_room_desc: 'Auditory +40%, Psychological +20%',
  room_science_lab: 'Science Lab',
  room_science_lab_desc: 'Visual +30%, Physical +25%',
  room_ticket_booth: 'Ticket Booth',
  room_ticket_booth_desc: 'Psych +25%, Visual +20%',
  room_animal_cage: 'Animal Cage',
  room_animal_cage_desc: 'Physical +30%, Visual +25%',
  room_clown_tent: 'Clown Tent',
  room_clown_tent_desc: 'Psych +40%, Visual +20%',
  room_hall_of_mirrors: 'Hall of Mirrors',
  room_hall_of_mirrors_desc: 'Visual +40%, Psych +30%',
  room_elevator_shaft: 'Elevator Shaft',
  room_elevator_shaft_desc: 'Physical +35%, Psych +20%',
  room_ore_processing: 'Ore Processing',
  room_ore_processing_desc: 'Auditory +30%, Physical +20%',
  room_collapsed_tunnel: 'Collapsed Tunnel',
  room_collapsed_tunnel_desc: 'Physical +40%, Psych +25%',
  room_miners_quarters: "Miners' Quarters",
  room_miners_quarters_desc: 'Psych +30%, Visual +20%',
  room_command_center: 'Command Center',
  room_command_center_desc: 'Psych +30%, Auditory +25%',
  room_ventilation_shaft: 'Ventilation Shaft',
  room_ventilation_shaft_desc: 'Physical +35%, Auditory +25%',
  room_decontamination: 'Decontamination',
  room_decontamination_desc: 'Psych +35%, Visual +25%',
  room_hollow_tree: 'Hollow Tree',
  room_hollow_tree_desc: 'Visual +30%, Psych +25%',
  room_spider_nest: 'Spider Nest',
  room_spider_nest_desc: 'Visual +35%, Physical +25%',
  room_moonlit_clearing: 'Moonlit Clearing',
  room_moonlit_clearing_desc: 'Psych +40%, Auditory +20%',
  room_abandoned_cabin: 'Abandoned Cabin',
  room_abandoned_cabin_desc: 'Psych +30%, Visual +20%',

  room_ward_room: 'Ward Room',
  room_ward_room_desc: 'Psych +30%, Visual +20%',
  room_reception_hall: 'Reception Hall',
  room_reception_hall_desc: 'Psych +25%, Auditory +20%',
  room_x_ray_room: 'X-Ray Room',
  room_x_ray_room_desc: 'Visual +35%, Physical +20%',
  room_classroom: 'Classroom',
  room_classroom_desc: 'Psych +30%, Auditory +15%',
  room_art_room: 'Art Room',
  room_art_room_desc: 'Visual +35%, Psych +20%',
  room_gymnasium: 'Gymnasium',
  room_gymnasium_desc: 'Physical +30%, Auditory +25%',
  room_rooftop: 'Rooftop',
  room_rooftop_desc: 'Psych +40%, Physical +20%',
  room_crypt: 'Crypt',
  room_crypt_desc: 'Visual +35%, Psych +25%',
  room_powder_room: 'Powder Room',
  room_powder_room_desc: 'Physical +40%, Auditory +20%',
  room_navigation_room: 'Navigation Room',
  room_navigation_room_desc: 'Psych +30%, Visual +20%',
  room_banquet_hall: 'Banquet Hall',
  room_banquet_hall_desc: 'Psych +30%, Visual +20%',
  room_chapel: 'Chapel',
  room_chapel_desc: 'Psych +40%, Auditory +20%',
  room_torture_chamber: 'Torture Chamber',
  room_torture_chamber_desc: 'Physical +40%, Visual +30%',
  room_armory_hall: 'Armory Hall',
  room_armory_hall_desc: 'Physical +30%, Visual +25%',
  room_science_room: 'Science Room',
  room_science_room_desc: 'Visual +30%, Psych +20%',

  // === Unlock Conditions ===
  unlock_requires_day: 'Day {n}+',
  unlock_requires_fame: 'Fame {n}+',
  unlock_requires_room: 'Requires: {name}',
  unlock_condition_not_met: 'Conditions not met',

  // === Synergy Names ===
  synergy_active_count: '{n} Synergies Active',
  synergy_popup_title: 'Active Synergies',
  syn_fx_dark_mirror_e1: 'Mirror Illusion',
  syn_fx_dark_mirror_e2: 'Doppelganger Curse',
  syn_fx_underground_horror_e1: 'Dungeon Scream',
  syn_fx_underground_horror_e2: 'Echo of Death',
  syn_fx_restless_spirits_e1: 'Sigh of the Departed',
  syn_fx_restless_spirits_e2: 'Ghost Procession',
  syn_fx_creepy_collection_e1: 'Curse of Dolls',
  syn_fx_creepy_collection_e2: 'Mirror Maze',
  syn_fx_mad_scientist_e1: 'Mad Experiment',
  syn_fx_mad_scientist_e2: 'Alchemist\'s Reward',
  syn_fx_hidden_paths_e1: 'Labyrinth of Shadows',
  syn_fx_hidden_paths_e2: 'Hidden Terror',
  syn_fx_circus_nightmare_e1: 'Clown\'s Play',
  syn_fx_circus_nightmare_e2: 'Circus Nightmare',
  syn_fx_ancient_curse_e1: 'Ancient Curse',
  syn_fx_ancient_curse_e2: 'Wrath of the Mummy',
  syn_fx_hidden_treasures_e1: 'Treasure\'s Temptation',
  syn_fx_hidden_treasures_e2: 'Underground Discovery',
  syn_fx_ship_of_doom_e1: 'Dirge of the Sea',
  syn_fx_ship_of_doom_e2: 'Davy Jones\' Wrath',
  syn_fx_prison_horror_e1: 'Prison Break',
  syn_fx_prison_horror_e2: 'Chains of Bondage',
  syn_fx_deep_descent_e1: 'Crystal Glow',
  syn_fx_deep_descent_e2: 'Underground Mystery',
  syn_fx_boom_scare_e1: 'Blast Aftermath',
  syn_fx_boom_scare_e2: 'Chain Explosion',
  syn_fx_royal_terror_e1: 'King\'s Wrath',
  syn_fx_royal_terror_e2: 'Royal Treasury',
  syn_fx_noble_cellar_e1: 'Bouquet of Ages',
  syn_fx_noble_cellar_e2: 'Secret Vault',
  syn_fx_quarantine_protocol_e1: 'Quarantine Alert',
  syn_fx_quarantine_protocol_e2: 'Biohazard',
  syn_fx_nature_wrath_e1: 'Witch\'s Fog',
  syn_fx_nature_wrath_e2: 'Nature\'s Wrath',
  syn_fx_ancient_power_e1: 'Ancient Force',
  syn_fx_ancient_power_e2: 'Mystic Ruins',
  syn_fx_echo_chamber_e1: 'Curse of Echoes',
  syn_fx_echo_chamber_e2: 'Sonic Illusion',
  syn_fx_water_horror_e1: 'Terror of the Deep',
  syn_fx_water_horror_e2: 'Whisper of Water',
  syn_fx_full_course_e1: 'Full Course Feast',
  syn_fx_full_course_e2: 'Smile of Satisfaction',
  synergy_dark_mirror: 'Dark Mirror',
  synergy_dark_mirror_desc: 'Dark Corridor + Mirror Room: Atmosphere +15%, Fear +10%',
  synergy_underground_horror: 'Underground Horror',
  synergy_underground_horror_desc: 'Dungeon/Coffin combo: Fear +20%, Scare +10%',
  synergy_restless_spirits: 'Restless Spirits',
  synergy_restless_spirits_desc: 'Graveyard/Coffin/Morgue: Atmosphere +20%, Visitors +10%',
  synergy_creepy_collection: 'Creepy Collection',
  synergy_creepy_collection_desc: 'Doll/Mirror/Funhouse: Fear +15%, Thrill +10%',
  synergy_mad_scientist: 'Mad Scientist',
  synergy_mad_scientist_desc: 'Lab/Surgery/Science: Thrill +20%, SP +15%',
  synergy_hidden_paths: 'Hidden Paths',
  synergy_hidden_paths_desc: 'Secret Passage/Corridor/Attic: Atmosphere +15%, Chain +20%',
  synergy_circus_nightmare: 'Circus Nightmare',
  synergy_circus_nightmare_desc: 'Funhouse/Freak Show/Trapeze: Fun +20%, Fear +15%',
  synergy_ancient_curse: 'Ancient Curse',
  synergy_ancient_curse_desc: 'Altar/Curse/Mummy: Fear +25%, Scare +15%',
  synergy_hidden_treasures: 'Hidden Treasures',
  synergy_hidden_treasures_desc: 'Vault + Underground River: SP +20%, Visitors +10%',
  synergy_ship_of_doom: 'Ship of Doom',
  synergy_ship_of_doom_desc: 'Captain/Cargo/Locker: Atmosphere +15%, Fear +15%',
  synergy_prison_horror: 'Prison Horror',
  synergy_prison_horror_desc: 'Brig + Locker: Thrill +20%, Scare +10%',
  synergy_deep_descent: 'Deep Descent',
  synergy_deep_descent_desc: 'Mine Shaft/Crystal/Lake: Atmosphere +20%, Visitors +15%',
  synergy_boom_scare: 'Boom Scare',
  synergy_boom_scare_desc: 'Explosives + Rail Tunnel: Thrill +25%, Chain +15%',
  synergy_royal_terror: 'Royal Terror',
  synergy_royal_terror_desc: 'Throne/Tower/Wine: Fear +15%, SP +20%',
  synergy_noble_cellar: 'Noble Cellar',
  synergy_noble_cellar_desc: 'Wine Cellar + Secret Passage: Atmosphere +15%, SP +10%',
  synergy_quarantine_protocol: 'Quarantine Protocol',
  synergy_quarantine_protocol_desc: 'Server/Quarantine/Armory: Thrill +20%, Fear +10%',
  synergy_nature_wrath: "Nature's Wrath",
  synergy_nature_wrath_desc: 'Witch/Swamp/Fairy: Atmosphere +20%, Scare +10%',
  synergy_ancient_power: 'Ancient Power',
  synergy_ancient_power_desc: 'Ruin/Fairy/Altar: Fear +20%, Visitors +15%',
  synergy_echo_chamber: 'Echo Chamber',
  synergy_echo_chamber_desc: 'Music/Library/Corridor: Chain +25%, Atmosphere +10%',
  synergy_water_horror: 'Water Horror',
  synergy_water_horror_desc: 'Bathroom/Underground River/Lake: Fear +15%, Atmosphere +15%',
  synergy_full_course: 'Full Course',
  synergy_full_course_desc: 'Kitchen/Bathroom/Music: Fun +25%, Visitors +20%',

  // === Ghost Management ===
  ghost_roster: 'Ghost Roster',
  ghost_idle: 'Idle',
  ghost_assigned: 'Assigned',
  ghost_fatigue: 'Fatigue',
  ghost_level: 'Lv.{n}',
  ghost_exp: 'EXP {cur}/{max}',
  ghost_level_up: 'Level Up',
  recover_fatigue: 'Recover Fatigue ({sp} SP)',
  ghost_fatigued_warning: 'Exhausted! Efficiency -50%',
  unassign_ghost: 'Unassign',
  ghost_training_in_progress: 'Training...',

  // === Shop ===
  shop_ghosts: 'Hire Ghosts',
  shop_rooms: 'Room Types',
  hire: 'Hire',
  hire_cost: '{sp} SP',
  already_hired: 'Hired',
  not_enough_sp: 'Not enough SP!',
  unlock_room_type: 'Unlock',
  unlock_cost: '{sp} SP',
  already_unlocked: 'Unlocked',

  // === Ghost Grades ===
  grade_c: 'Grade C',
  grade_b: 'Grade B',
  grade_a: 'Grade A',
  grade_s: 'Grade S',

  // === Ghost Names ===
  ghost_jinaeryeong: 'Jinaeryeong',
  ghost_gangsi: 'Jiangshi',
  ghost_vampire: 'Vampire',
  ghost_kappa: 'Kappa',
  ghost_pierrot: 'Pierrot',
  ghost_banshee: 'Banshee',
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',

  // === Ghost Origins ===
  ghost_origin_korea: 'Korea',
  ghost_origin_china: 'China',
  ghost_origin_romania: 'Romania',
  ghost_origin_japan: 'Japan',
  ghost_origin_usa: 'USA',
  ghost_origin_ireland: 'Ireland',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',

  // === Ghost Skills ===
  ghost_jinaeryeong_skill: 'Hair Drop: Falls from ceiling for extra physical scare',
  ghost_gangsi_skill: 'Stiff Jump: Leaps stiffly to scare 2 visitors at once',
  ghost_vampire_skill: "Hypno Eyes: Freezes a visitor for 10s, next room +30% scare",
  ghost_kappa_skill: 'Plate Spin: Spins head plate for visual scare',
  ghost_pierrot_skill: 'Laugh Attack: Sudden appearance, clown fear',
  ghost_banshee_skill: 'Shriek: Max auditory scare, can trigger repeatedly',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',

  // === Ghost Quotes ===
  ghost_jinaeryeong_quote: 'I scared 10 visitors today, boss!',
  ghost_gangsi_quote: 'Jumping around is hard work...',
  ghost_vampire_quote: 'The night is young, and so am I.',
  ghost_kappa_quote: "Don't spill the water!",
  ghost_pierrot_quote: 'Why so serious?',
  ghost_banshee_quote: 'My throat hurts from all the screaming.',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',

  // === Ghost Fatigued Quotes ===
  ghost_jinaeryeong_fatigued: 'Boss... my hair is everywhere, I need a break!',
  ghost_gangsi_fatigued: "I can't move anymore... literally.",
  ghost_vampire_fatigued: "Even immortals need rest...",
  ghost_kappa_fatigued: 'My plate dried out, I need water!',
  ghost_pierrot_fatigued: "I'm not laughing anymore, boss.",
  ghost_banshee_fatigued: "My voice is gone! I can't scream!",
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',

  // === Room Build Popup ===
  room_unlock_in_shop: 'Unlock in Shop',

  // === Visitor Types ===
  visitor_scaredy_kid: 'Scaredy Kid',
  visitor_scaredy_kid_desc: 'Easily scared but satisfied with little',
  visitor_normal: 'Visitor',
  visitor_normal_desc: 'Average fear tolerance',
  visitor_brave: 'Brave One',
  visitor_brave_desc: 'High tolerance, big reward when satisfied',
  visitor_couple: 'Couple',
  visitor_couple_desc: 'Moderate fear, high reward, good reviews',
  visitor_youtuber: 'Youtuber',
  visitor_youtuber_desc: 'Reviews have 2.5x influence on fame',
  visitor_exorcist: 'Exorcist',
  visitor_exorcist_desc: 'Nearly impossible to scare, huge reward',
  visitor_thrill_seeker: 'Thrill Seeker',
  visitor_thrill_seeker_desc: 'Wants intense scares, impatient with weak ones',
  visitor_coward: 'Coward',
  visitor_coward_desc: 'Terrified of everything, flees easily',

  // === Time Phase ===
  time_phase_day: 'Day',
  time_phase_evening: 'Evening',
  time_phase_night: 'Night',
  time_phase_rain: 'Rain',

  // === Reputation ===
  reputation_label: 'Rep: {n}',

  // === Scare Feedback ===
  scare_chain: 'Chain x{n}!',
  terror_max: 'TERROR MAX!',
  sp_earned: '+{sp} SP',

  // === Prestige ===
  prestige_title: 'Franchise Expansion',
  prestige_desc: 'Your haunted house is world-famous! Open a franchise?',
  prestige_requirement_floors: '{n} floors required',
  prestige_requirement_fame: '{n} Fame required',
  prestige_requirement_sp: '{n} total SP required',
  prestige_not_ready: 'Requirements not met',
  prestige_confirm: 'Expand Franchise',
  prestige_level: 'Prestige Lv.{n}',
  prestige_bonus: 'All ghosts +{n}% scare, +{sp} starting SP',

  // === Offline reward ===
  offline_collect: 'Collect',

  // === Training System ===
  training_title: 'Acting Class',
  training_select: 'Choose Training',
  training_cost: '{sp} SP',
  training_duration: '{sec}s',
  training_in_progress: 'Training in progress...',
  training_complete: 'Training Complete!',
  training_bonus: 'Scare +{pct}%',
  training_skip_ad: 'Skip (Ad)',
  training_count: '{n} sessions completed',
  training_ghost_busy: 'Unassign ghost first',
  training_already: 'Already training',

  training_scream_practice: 'Scream Practice',
  training_scream_practice_desc: 'Improve vocal projection and timing',
  training_jumpscare_acting: 'Jumpscare Acting',
  training_jumpscare_acting_desc: 'Master the art of sudden appearance',
  training_psychological_acting: 'Psychological Horror',
  training_psychological_acting_desc: 'Learn to create lingering dread',
  training_atmosphere_directing: 'Atmosphere Directing',
  training_atmosphere_directing_desc: 'Control lighting, sound, and fog cues',
  training_physical_training: 'Physical Training',
  training_physical_training_desc: 'Build stamina for energetic scares',
  training_audience_analysis: 'Audience Analysis',
  training_audience_analysis_desc: 'Study visitor behavior for optimal scares',

  // === Training Comedy Quotes ===
  tq_jinaeryeong_scream: 'Jinaeryeong watching horror movie analysis on YouTube...',
  tq_gangsi_scream: 'Jiangshi practicing screams while standing stiff...',
  tq_vampire_scream: 'Vampire humming opera in the basement...',
  tq_kappa_scream: 'Kappa gurgling underwater screams in a bucket...',
  tq_pierrot_scream: 'Pierrot screaming into a balloon...',
  tq_banshee_scream: 'Banshee teaching a masterclass to beginners...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',

  tq_jinaeryeong_jumpscare: 'Jinaeryeong jumping out of closets repeatedly...',
  tq_gangsi_jumpscare: 'Jiangshi stretching before jump practice...',
  tq_vampire_jumpscare: 'Vampire practicing dramatic cape reveals...',
  tq_kappa_jumpscare: 'Kappa popping out of toilet bowls...',
  tq_pierrot_jumpscare: 'Pierrot rehearsing balloon pop timing...',
  tq_banshee_jumpscare: 'Banshee working on her entrance choreography...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',

  tq_jinaeryeong_psych: 'Jinaeryeong studying psychology textbooks...',
  tq_gangsi_psych: 'Jiangshi trying to look creepy (already does)...',
  tq_vampire_psych: 'Vampire practicing in front of mirror... (nothing reflects)',
  tq_kappa_psych: 'Kappa learning about human fears from a library book...',
  tq_pierrot_psych: 'Pierrot watching "It" for the 50th time...',
  tq_banshee_psych: 'Banshee writing creepy whisper scripts...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',

  tq_jinaeryeong_atmo: 'Jinaeryeong arranging her hair for maximum creep factor...',
  tq_gangsi_atmo: 'Jiangshi adjusting the fog machine settings...',
  tq_vampire_atmo: 'Vampire choosing the perfect candlelight angle...',
  tq_kappa_atmo: 'Kappa testing different water drip sounds...',
  tq_pierrot_atmo: 'Pierrot painting the walls with glow-in-dark paint...',
  tq_banshee_atmo: 'Banshee calibrating echo effects in the hallway...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',

  tq_jinaeryeong_physical: 'Jinaeryeong doing ceiling-crawl exercises...',
  tq_gangsi_physical: 'Jiangshi doing stiff-legged squats...',
  tq_vampire_physical: 'Vampire doing push-ups in his coffin...',
  tq_kappa_physical: 'Kappa swimming laps in the pond...',
  tq_pierrot_physical: 'Pierrot juggling while doing sit-ups...',
  tq_banshee_physical: 'Banshee doing vocal cord warm-ups...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',

  tq_jinaeryeong_audience: 'Jinaeryeong reading visitor reviews online...',
  tq_gangsi_audience: 'Jiangshi studying visitor flow patterns...',
  tq_vampire_audience: 'Vampire analyzing fear demographics...',
  tq_kappa_audience: 'Kappa surveying which age groups fear water...',
  tq_pierrot_audience: 'Pierrot tracking coulrophobia statistics...',
  tq_banshee_audience: 'Banshee studying sound frequency fear responses...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  // === Props ===
  props_title: 'Room Decorations',
  prop_buy: 'Buy ({sp} SP)',
  prop_upgrade: 'Upgrade ({sp} SP)',
  prop_max: 'MAX',
  prop_level: 'Lv.{n}',
  prop_bonus: '+{pct}% scare',

  prop_cobwebs: 'Cobwebs',
  prop_cobwebs_desc: 'Classic spooky atmosphere',
  prop_candles: 'Flickering Candles',
  prop_candles_desc: 'Eerie dancing shadows',
  prop_blood_pool: 'Blood Pool',
  prop_blood_pool_desc: 'Horrifying floor decoration',
  prop_skull_decor: 'Skull Decoration',
  prop_skull_decor_desc: 'Bone-chilling display',
  prop_fog_machine: 'Fog Machine',
  prop_fog_machine_desc: 'Thick mysterious fog',
  prop_creaky_floor: 'Creaky Floorboards',
  prop_creaky_floor_desc: 'Every step makes noise',
  prop_eerie_painting: 'Eerie Painting',
  prop_eerie_painting_desc: 'Eyes that follow you',
  prop_chains: 'Rattling Chains',
  prop_chains_desc: 'Haunting metallic sounds',

  // Staging Equipment
  prop_dry_ice: 'Dry Ice Machine',
  prop_dry_ice_desc: 'Creates thick ground fog for eerie atmosphere',
  prop_scent_sprayer: 'Scent Sprayer',
  prop_scent_sprayer_desc: 'Releases unsettling smells for immersive horror',
  prop_strobe_light: 'Strobe Light',
  prop_strobe_light_desc: 'Flickering flashes that disorient visitors',
  prop_surround_speaker: 'Surround Speaker',
  prop_surround_speaker_desc: 'Spatial audio for terrifying sound effects',
  prop_vibration_floor: 'Vibration Floor Panel',
  prop_vibration_floor_desc: 'Sudden tremors beneath visitors feet',
  prop_temp_controller: 'Temperature Controller',
  prop_temp_controller_desc: 'Blasts of cold air for psychological dread',
  prop_hologram_device: 'Hologram Device',
  prop_hologram_device_desc: 'Projects ghostly apparitions into the room',
  prop_auto_lock: 'Auto Door Lock',
  prop_auto_lock_desc: 'Doors slam shut unexpectedly behind visitors',

  // Props categories
  props_category_decoration: 'Decoration Props',
  props_category_staging: 'Staging Equipment',
  props_staging_desc: 'Advanced equipment for professional scare effects',

  // === Facilities ===
  facilities_title: 'Auxiliary Facilities',
  facility_build: 'Build ({sp} SP)',
  facility_upgrade: 'Upgrade ({sp} SP)',
  facility_level: 'Lv.{n}',
  facility_built: 'Built',

  facility_haunted_house: 'Haunted House',
  facility_haunted_house_desc: 'Main horror experience building',
  facility_haunted_house_bonus: 'Main building entrance',
  facility_enter: 'Enter',

  facility_ticket_booth: 'Ticket Booth',
  facility_ticket_booth_desc: 'Sells admission tickets to visitors',
  facility_ticket_booth_bonus: 'Increases max visitor capacity',
  facility_ticket_booth_visitors: 'visitors',

  facility_gift_shop: 'Gift Shop',
  facility_gift_shop_desc: 'Sells haunted house souvenirs',
  facility_gift_shop_bonus: '+{sp} SP per visitor group',
  facility_snack_bar: 'Snack Bar',
  facility_snack_bar_desc: 'Spooky snacks and drinks',
  facility_snack_bar_bonus: '+{pct}% visitor reward',
  facility_photo_booth: 'Photo Booth',
  facility_photo_booth_desc: 'Terror selfie station',
  facility_photo_booth_bonus: '+{sp} SP per visitor group',

  // === Reviews ===
  reviews_title: 'Visitor Reviews',
  reviews_empty: 'No reviews yet. Wait for visitors!',
  reviews_fame_bonus: '+{n} Fame',
  review_stars: '{n} stars',
  reviews_avg: 'Average: {n} stars',

  // 5 star reviews
  review_5_1: 'Genuinely terrifying! {ghost} on floor 3 was next level!',
  review_5_2: 'Best haunted house ever! I screamed so hard I lost my voice!',
  review_5_3: 'The {ghost} performance was Oscar-worthy! 10/10 would scream again!',
  review_5_4: 'My soul almost left my body. Worth every penny!',
  // 4 star reviews
  review_4_1: '{ghost} was pretty scary, but I expected more from the upper floors.',
  review_4_2: 'Great atmosphere! Almost peed my pants. Almost.',
  review_4_3: '{ghost} was impressive but the timing could be better.',
  review_4_4: 'Solid scares throughout. Would recommend to friends!',
  // 3 star reviews
  review_3_1: 'It was okay. Some rooms were empty which killed the mood.',
  review_3_2: '{ghost} seemed tired today. Take a break maybe?',
  review_3_3: 'Average experience. Could use more decorations.',
  // 2 star reviews
  review_2_1: '{ghost} was literally sleeping on the job. Refund please.',
  review_2_2: 'More funny than scary. The ghosts need acting lessons.',
  review_2_3: '{ghost} tried their best but... it was not scary at all.',
  // 1 star reviews
  review_1_1: 'Empty rooms everywhere. Is this even open?',
  review_1_2: 'I want my money back. My grandma is scarier.',
  review_1_3: '{ghost} waved at me. WAVED. That is not how haunting works.',

  // Street visitor reviews
  review_street_5star: 'The whole park is amazing! Haunted house was terrifying, and the facilities are top-notch!',
  review_street_4star: 'Great experience overall. The haunted house was scary and the snacks were good.',
  review_street_3star: 'Decent park. The haunted house could use more ghosts though.',
  review_street_2star: 'Not much to do here. The haunted house was underwhelming.',
  review_street_1star: 'Waste of time. Nothing scary and barely any facilities.',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',

  // === Ad Rewards ===
  ad_sp_boost: '2x SP Boost (30s)',
  ad_sp_boost_desc: 'Double all SP earnings for 30 seconds',
  ad_recover_fatigue: 'Free Recovery',
  ad_recover_fatigue_desc: 'Fully recover ghost fatigue for free',
  ad_vip_visitor: 'VIP Visitors',
  ad_vip_visitor_desc: 'Summon a high-reward visitor group',
  ad_skip_training: 'Skip Training',
  ad_skip_training_desc: 'Complete training instantly',
  ad_active_boost: '2x SP Active!',
  ad_rewards_title: 'Ad Rewards',

  // === Business / Open-Close System ===
  day_label: 'Day {n}',
  hud_operation_day: 'Day {n}',
  status_open: 'OPEN',
  status_closed: 'CLOSED',
  manage_business: 'Manage Business',
  toggle_open: 'Open for Business',
  toggle_close: 'Close Business',
  facility_open_badge: 'OPEN',
  need_ghost_to_open: 'Assign a ghost to a room first!',
  ticket_price: 'Ticket Price',
  ticket_price_label: '{n} SP',
  ticket_price_low: 'More visitors, less revenue per visitor',
  ticket_price_high: 'Fewer visitors, more revenue per visitor',
  end_day: 'End Day',
  day_summary_title: 'DAY {n} SUMMARY',
  day_summary_visitors: 'Visitors: {n}',
  day_summary_earnings: 'Earnings: {n} SP',
  day_summary_avg_rating: 'Avg Rating: {n}',
  day_summary_next: 'END DAY & COLLECT REWARDS',
  day_summary_best_visitor: '{n}-STAR VISIT!',
  day_summary_sp_collected: 'TOTAL SP COLLECTED',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: 'DAILY MILESTONES',
  day_summary_total_visits: 'TOTAL VISITS',
  day_summary_street_visitors: 'STREET VISITORS',
  day_summary_street_revenue: 'Street Revenue',
  day_summary_reaction_5: 'TERRIFYING!',
  day_summary_reaction_4: 'GREAT HAUNT!',
  day_summary_reaction_3: 'NOT BAD',
  day_summary_reaction_2: 'MEH...',
  day_summary_reaction_1: 'BORING...',

  // === Daily Milestones ===
  milestone_visitors_5: 'Welcome {target} visitors',
  milestone_visitors_10: 'Welcome {target} visitors',
  milestone_visitors_20: 'Welcome {target} visitors',
  milestone_earnings_1000: 'Earn {target} SP',
  milestone_earnings_5000: 'Earn {target} SP',
  milestone_earnings_10000: 'Earn {target} SP',
  milestone_flee_0: 'Zero fleeing visitors',
  milestone_flee_1: 'Max {target} fleeing visitor',
  milestone_rooms_3: 'Operate {target}+ rooms',
  milestone_rooms_5: 'Operate {target}+ rooms',
  milestone_ghosts_2: 'Deploy {target}+ ghosts',
  milestone_ghosts_3: 'Deploy {target}+ ghosts',
  milestone_reward: '+{n} SP',

  // === Review Panel ===
  reviews_panel_title: 'VISITOR REVIEWS',
  reviews_panel_avg: 'Average Rating',
  reviews_panel_empty: 'No reviews yet',

  // === View Switcher ===
  view_building: 'Building',
  view_other_buildings: '< Other Buildings',
  view_lobby: 'Lobby',
  view_facilities: 'Facilities',
  view_academy: 'Academy',

  // === Lobby View ===
  lobby_title: 'Lobby',
  lobby_queue: 'Waiting Queue',
  lobby_queue_empty: 'No visitors waiting',
  lobby_active_teams: 'Teams Exploring: {cur}/{max}',
  lobby_wait_time: 'Wait: {n}s',
  lobby_team_size: '{n} visitors',
  lobby_staff: 'Lobby Staff',
  lobby_staff_empty: 'No staff assigned',
  lobby_assign_staff: 'Assign Staff',
  lobby_unassign_staff: 'Unassign',
  lobby_staff_effect: 'Reduces wait time, improves visitor satisfaction',
  lobby_ticket_booth: 'Ticket Booth',

  // === Facilities View ===
  facilities_view_title: 'Facility Management',
  facilities_view_empty: 'No facilities built yet. Build in the Menu tab!',
  facility_staff: 'Staff',
  facility_staff_none: 'No staff',
  facility_assign_staff: 'Assign Staff',
  facility_unassign_staff: 'Unassign Staff',
  facility_staff_bonus: 'Staff improves service quality',
  facility_restroom: 'Restroom',
  facility_restroom_desc: 'Prevents satisfaction penalty',
  facility_restroom_bonus: 'No penalty when built',
  facility_parking_lot: 'Parking Lot',
  facility_parking_lot_desc: 'Increases visitor arrival rate',
  facility_parking_lot_bonus: '+{pct}% visitor rate per level',
  facility_first_aid: 'First Aid Station',
  facility_first_aid_desc: 'Care for fled/fainted visitors',
  facility_first_aid_bonus: 'Prevents bad reviews from fleeing',

  facility_arcade: 'Arcade',
  facility_arcade_desc: 'Mini-games & horror attractions',
  facility_arcade_bonus: 'Increases visitor excitement',
  facility_fortune_teller: 'Fortune Teller',
  facility_fortune_teller_desc: 'Mysterious tarot & palm readings',
  facility_fortune_teller_bonus: 'Boosts visitor satisfaction',
  facility_escape_room: 'Escape Room',
  facility_escape_room_desc: 'Timed horror puzzle challenge',
  facility_escape_room_bonus: 'High revenue per visitor',
  facility_stage: 'Stage',
  facility_stage_desc: 'Ghost performances & shows',
  facility_stage_bonus: 'Increases park-wide fame',
  facility_voodoo_shop: 'Voodoo Shop',
  facility_voodoo_shop_desc: 'Cursed dolls & dark rituals',
  facility_voodoo_shop_bonus: 'Boosts scare power of nearby rooms',
  facility_ghost_cafe: 'Ghost Cafe',
  facility_ghost_cafe_desc: 'Spectral beverages & ghostly treats',
  facility_ghost_cafe_bonus: 'Restores visitor patience',
  facility_phantom_cinema: 'Phantom Cinema',
  facility_phantom_cinema_desc: 'Haunted film screenings',
  facility_phantom_cinema_bonus: 'High revenue per showing',
  facility_skeleton_spa: 'Skeleton Spa',
  facility_skeleton_spa_desc: 'Bone-chilling relaxation',
  facility_skeleton_spa_bonus: 'Reduces ghost fatigue',

  // === Academy View ===
  academy_title: 'Ghost Academy',
  academy_empty: 'Hire ghosts first to start training!',
  academy_select_ghost: 'Select a ghost to train',
  academy_select_training: 'Choose Training Course',
  academy_skill_level: 'Lv.{n}/{max}',
  academy_skill_maxed: 'MASTERED',
  academy_training_time: '{sec}s',
  academy_training_cost: '{sp} SP',
  academy_in_progress: 'Training...',
  academy_complete: 'Complete!',
  academy_skip_ad: 'Skip (Ad)',
  academy_ghost_busy: 'Ghost is busy',

  // Academy Training Types
  academy_acting: 'Acting Class',
  academy_acting_desc: 'Improve scare performance and timing',
  academy_acting_effect: 'Scare effect +20% per level',
  academy_human_relations: 'Human Relations',
  academy_human_relations_desc: 'Learn to understand visitors',
  academy_human_relations_effect: 'Satisfaction +15% per level',
  academy_psychology: 'Psychology',
  academy_psychology_desc: 'Target visitor weaknesses',
  academy_psychology_effect: 'Weakness hit bonus per level',
  academy_special_fx: 'Special FX',
  academy_special_fx_desc: 'Master prop and effect usage',
  academy_special_fx_effect: 'Prop bonus x2 per level',
  academy_fitness: 'Fitness',
  academy_fitness_desc: 'Build stamina and endurance',
  academy_fitness_effect: 'Fatigue recovery +50% per level',
  academy_teamwork: 'Teamwork',
  academy_teamwork_desc: 'Coordinate with nearby ghosts',
  academy_teamwork_effect: 'Chain scare +30% per level',
  academy_customer_service: 'Customer Service',
  academy_customer_service_desc: 'Improve lobby/facility service',
  academy_customer_service_effect: 'Service quality boost per level',

  // === Facility Detail View ===
  facility_detail_income: 'Income',
  facility_detail_sp_per_group: '{n} SP / group',
  facility_detail_bonus: 'Bonus',
  facility_detail_upgrade: 'Upgrade ({sp} SP)',
  facility_detail_assign: 'Assign Staff',
  facility_detail_status_active: 'Operating',
  facility_detail_status_buildable: 'Available',
  facility_detail_status_locked: 'Locked',
  facility_detail_no_income: 'No direct income',

  // === Ghost Roles ===
  ghost_role_scare: 'Scare Duty',
  ghost_role_lobby_staff: 'Lobby Staff',
  ghost_role_facility_staff: 'Facility Staff',
  ghost_role_instructor: 'Instructor',

  // === Pro Ghosts ===
  shop_pro_ghosts: 'Professional Ghosts',
  pro_ghost_badge: 'PRO',

  ghost_grim_reaper: 'Grim Reaper',
  ghost_origin_underworld: 'Underworld',
  ghost_grim_reaper_skill: 'Soul Harvest: All fear types S-rank, absolute terror',
  ghost_grim_reaper_quote: 'Your time has come... just kidding. Or am I?',
  ghost_grim_reaper_fatigued: 'Even death needs a vacation sometimes...',
  ghost_grim_reaper_unique: 'Instant max fear on any visitor type',

  ghost_blood_count: 'Blood Count',
  ghost_origin_transylvania: 'Transylvania',
  ghost_blood_count_skill: 'Blood Charm: Charisma-based visual + psychological S-rank',
  ghost_blood_count_quote: 'I do not drink... wine.',
  ghost_blood_count_fatigued: 'The sun... it burns... need coffin...',
  ghost_blood_count_unique: 'Charm aura: adjacent rooms get +20% scare',

  ghost_well_spirit: 'Well Spirit',
  ghost_well_spirit_skill: 'Well Crawl: Psychological horror S-rank, lingering dread',
  ghost_well_spirit_quote: '...seven days...',
  ghost_well_spirit_fatigued: 'My hair is so tangled... need conditioner...',
  ghost_well_spirit_unique: 'Lingering fear: visitors stay scared in next room',

  ghost_nightmare_specter: 'Nightmare Specter',
  ghost_origin_dreamworld: 'Dream World',
  ghost_nightmare_specter_skill: 'Nightmare Slash: Physical + psychological S-rank dream terror',
  ghost_nightmare_specter_quote: 'Sweet dreams... or not.',
  ghost_nightmare_specter_fatigued: 'Even nightmares need beauty sleep...',
  ghost_nightmare_specter_unique: 'Dream invasion: double scare on sleeping visitors',

  ghost_shadow_stalker: 'Shadow Stalker',
  ghost_origin_void: 'The Void',
  ghost_shadow_stalker_skill: 'Static Presence: Psychological horror max, stalker-type',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: 'Static aura: all visitors on floor get +15% fear',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  // === Lobby Building System ===
  lobby_room_ticket_booth: 'Ticket Booth',
  lobby_room_ticket_booth_desc: 'Where visitors purchase their tickets',
  lobby_room_ticket_booth_effect: 'Base ticket processing speed',
  lobby_room_waiting_lounge: 'Waiting Lounge',
  lobby_room_waiting_lounge_desc: 'Comfortable waiting area with seating',
  lobby_room_waiting_lounge_effect: '+20% visitor patience per level',
  lobby_room_vip_lounge: 'VIP Lounge',
  lobby_room_vip_lounge_desc: 'Premium waiting area for VIP visitors',
  lobby_room_vip_lounge_effect: 'VIP visitors spend 2x more SP',
  lobby_room_reservation_center: 'Reservation Center',
  lobby_room_reservation_center_desc: 'Pre-booking system for visitors',
  lobby_room_reservation_center_effect: '+15% visitor spawn rate per level',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: 'Select facility to build...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: 'Build Facility',
  lobby_select_facility: 'Select Facility',
  lobby_props_count: '{n} props',
  lobby_props_title: 'Objects',
  lobby_tab_info: 'Info',
  lobby_tab_objects: 'Objects',
  lobby_tab_upgrade: 'Upgrade',
  lobby_tab_demolish: 'Demolish',
  lobby_demolish_confirm: 'Remove this facility? The floor will become empty.',
  lobby_demolish_btn: 'Demolish Facility',
  lobby_no_ghost: 'No staff',
  lobby_upgrade_max: 'Max Level',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: 'Effect after upgrade:',
  facility_build_floor: 'Build',

  // === Facility Map (Plot Grid) ===
  facility_map_title: 'Facility Area',
  facility_build_here: 'Build',
  facility_select_to_build: 'Select Facility',
  facility_all_built: 'All facilities have been built.',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: 'Unlock Plot',
  facility_unlock_plot_desc: 'Unlock this plot for {sp} SP to build a new facility.',
  facility_unlock_plot_btn: 'Unlock ({sp} SP)',
  facility_build_popup_title: 'Build Facility',
  facility_build_action: 'Build',
  facility_select_theme: 'Select Theme',
  facility_upgrade_preview: 'Upgrade Effects',
  facility_upgrade_revenue: 'Revenue per group',
  facility_upgrade_bonus: 'Revenue Bonus',
  facility_upgrade_capacity: 'Capacity',
  facility_upgrade_current: 'Current',
  facility_upgrade_next: 'Next',
  facility_upgrade_max_level: 'Max Level Reached',
  facility_revenue: 'Revenue',
  facility_total_revenue: 'Total Revenue',
  facility_hourly_revenue: 'Per Group',
  facility_set_price: 'Set Price',
  facility_price_hint_high: 'High price: more profit, fewer visitors',
  facility_price_hint_low: 'Low price: more visitors, less profit',
  facility_price_hint_free: 'Free admission',
  facility_price_hint_normal: 'Balanced pricing',
  facility_open: 'Open',
  facility_close: 'Close',
  facility_closed_badge: 'CLOSED',
  facility_needs_staff: 'Assign Staff to Open',
  facility_demolish: 'Demolish',
  facility_demolish_confirm: 'Demolish {name}? This cannot be undone.',
  facility_move: 'Move',
  facility_move_select: 'Select an empty plot to move to',
  facility_move_no_empty: 'No empty plots available.',

  // === Lobby Props ===
  lobby_prop_sofa: 'Sofa',
  lobby_prop_sofa_desc: 'Comfortable seating for waiting visitors',
  lobby_prop_tv_screen: 'TV Screen',
  lobby_prop_tv_screen_desc: 'Entertainment while waiting',
  lobby_prop_vending_machine: 'Vending Machine',
  lobby_prop_vending_machine_desc: 'Snacks and drinks for visitors',
  lobby_prop_info_sign: 'Info Sign',
  lobby_prop_info_sign_desc: 'Guide visitors to the right place',
  lobby_prop_potted_plant: 'Potted Plant',
  lobby_prop_potted_plant_desc: 'Adds a touch of eerie greenery',
  lobby_prop_umbrella_stand: 'Umbrella Stand',
  lobby_prop_umbrella_stand_desc: 'A place for wet umbrellas',

  // === Facility Props ===
  fac_prop_display_shelf: 'Display Shelf',
  fac_prop_display_shelf_desc: 'Showcase products attractively',
  fac_prop_cash_register: 'Cash Register',
  fac_prop_cash_register_desc: 'Speed up transactions',
  fac_prop_coffee_machine: 'Coffee Machine',
  fac_prop_coffee_machine_desc: 'Serve hot beverages',
  fac_prop_menu_board: 'Menu Board',
  fac_prop_menu_board_desc: 'Display food and drink options',
  fac_prop_camera_light: 'Camera Light',
  fac_prop_camera_light_desc: 'Better lighting for photos',
  fac_prop_backdrop: 'Backdrop',
  fac_prop_backdrop_desc: 'Themed photo background',
  fac_prop_hand_dryer: 'Hand Dryer',
  fac_prop_hand_dryer_desc: 'Keep things clean and dry',
  fac_prop_mirror: 'Mirror',
  fac_prop_mirror_desc: 'A creepy bathroom essential',
  fac_prop_parking_sign: 'Parking Sign',
  fac_prop_parking_sign_desc: 'Direct visitors to parking',
  fac_prop_barrier_gate: 'Barrier Gate',
  fac_prop_barrier_gate_desc: 'Automated parking control',
  fac_prop_first_aid_kit: 'First Aid Kit',
  fac_prop_first_aid_kit_desc: 'Basic medical supplies',
  fac_prop_stretcher: 'Stretcher',
  fac_prop_stretcher_desc: 'For visitors who faint from fear',

  // === New Tab Names ===
  tab_facilities: 'Facilities',
  tab_hire: 'Hire',
  tab_staff: 'Staff',
  tab_support_facilities: 'Facilities',
  tab_achievements: 'Achievements',
  achievements_title: 'Achievements',
  achievements_coming_soon: 'Coming soon...',

  // === Facilities Management Tab ===
  facilities_mgmt_title: 'Facility Management',
  facility_condition: 'Condition',
  facility_hygiene: 'Hygiene',
  facility_condition_warning: 'Needs repair!',
  facility_hygiene_warning: 'Needs cleaning!',
  dispatch_repair: 'Dispatch Repair',
  dispatch_clean: 'Dispatch Clean',
  no_repair_staff: 'No repair staff available',
  no_janitor_staff: 'No cleaning staff available',
  repair_dispatched: 'Repair crew dispatched',
  clean_dispatched: 'Cleaning crew dispatched',

  // === Ticket Price Section ===
  ticket_section_title: 'Ticket Price',
  expected_visitors: 'Expected visitors: ~{n}/day',

  // === Star Evolution System ===
  star_rating_title: 'Visitor Rating',
  star_level_gray: 'Gray Star',
  star_level_bronze: 'Bronze Star',
  star_level_silver: 'Silver Star',
  star_level_gold: 'Gold Star',
  star_level_rainbow: 'Rainbow Star',
  star_evolution_max: 'The Greatest Haunted House',
  star_current: '{cur}/{max}',

  // === Hire Tab ===
  hire_title: 'Hire Staff',
  hire_scare_section: 'Scare Specialists',
  hire_staff_section: 'Facility Staff',
  staff_role_repair: 'Repairman',
  staff_role_janitor: 'Janitor',
  staff_role_ticket: 'Ticket Seller',
  staff_role_guide: 'Guide',
  staff_role_repair_desc: 'Repairs facility deterioration',
  staff_role_janitor_desc: 'Maintains facility hygiene',
  staff_role_ticket_desc: 'Operates the lobby',
  staff_role_guide_desc: 'Visitor satisfaction bonus',
  hire_cost_label: '{sp} SP',

  // === Staff Tab ===
  staff_title: 'Staff List',
  staff_empty: 'No staff hired yet.',
  staff_detail_title: 'Staff Detail',
  staff_detail_type: 'Type',
  staff_detail_role: 'Role',
  staff_detail_grade: 'Grade',
  staff_detail_skills: 'Skills',
  staff_detail_assigned: 'Assigned To',
  staff_detail_not_assigned: 'Not Assigned',
  staff_detail_hired_days: 'Employed: Day {n}',
  staff_detail_praise: 'Praise: {n}',
  skill_acting: 'Acting',
  skill_friendliness: 'Friendliness',
  skill_psychology: 'Psychology',
  skill_special_fx: 'Special FX',
  skill_fitness: 'Fitness',
  skill_teamwork: 'Teamwork',
  skill_service: 'Service',

  // === Room Detail Popup ===
  room_detail_tab_info: 'Info',
  room_detail_tab_props: 'Props',
  room_detail_tab_upgrade: 'Upgrade',
  room_detail_tab_demolish: 'Demolish',
  room_detail_ghost_none: 'Not assigned',
  room_detail_condition: 'Condition',
  room_detail_hygiene: 'Hygiene',
  room_detail_request_repair: 'Request Repair ({sp} SP)',
  room_detail_request_cleaning: 'Request Cleaning ({sp} SP)',
  room_detail_repairing: 'Repairing... {sec}s',
  room_detail_cleaning: 'Cleaning... {sec}s',
  room_detail_collapsed: 'COLLAPSED',
  room_detail_collapsed_desc: 'This room has collapsed. Repair to restore.',
  room_detail_condition_ok: 'Condition is good',
  room_detail_hygiene_ok: 'Hygiene is good',
  // Upgrade tab
  room_upgrade_structure: 'Structural Reinforcement',
  room_upgrade_structure_desc: 'Reduces condition deterioration per visit',
  room_upgrade_structure_effect: '-{pct}% condition loss per level',
  room_upgrade_structure_bonus_10: 'Sturdy Room: Repair cost -30%',
  room_upgrade_structure_bonus_20: 'Immortal Room: Condition minimum 50',
  room_upgrade_purify: 'Auto Purification',
  room_upgrade_purify_desc: 'Reduces hygiene deterioration per visit',
  room_upgrade_purify_effect: '-{pct}% hygiene loss per level',
  room_upgrade_purify_bonus_10: 'Fragrant Room: Satisfaction +10%',
  room_upgrade_purify_bonus_20: 'Self-Cleaning Magic: Auto hygiene recovery',
  room_upgrade_level: 'Lv.{cur}/{max}',
  room_upgrade_cost: 'Upgrade ({sp} SP)',
  room_upgrade_max: 'MAX',
  room_upgrade_bonus_unlocked: 'Unlocked!',
  room_upgrade_bonus_locked: 'Lv.{n} Bonus',
  // Demolish tab
  room_demolish_warning: 'Demolishing this room will destroy all props and upgrades permanently.',
  room_demolish_cost: 'Cost: Free',
  room_demolish_btn: 'Demolish Room',
  room_demolish_confirm: 'Are you sure you want to demolish this room? This cannot be undone.',
  // Props tab (in room detail)
  room_props_installed: 'Installed Props',
  room_props_available: 'Available Props',
  room_props_none: 'No props installed',

  // === Menu Tab (New) ===
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: 'Language',
  menu_reset: 'Reset Game',
  menu_reset_confirm: 'Are you sure you want to reset all progress? This cannot be undone.',
  menu_info: 'Game Info',
  menu_version: 'Version {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: 'Fear',
  stat_thrill: 'Thrill',
  stat_atmosphere: 'Vibe',
  stat_fun: 'Fun',
  stat_total: 'Room Stats',
  room_grade: 'Grade',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  // === Day Phase Cycle ===
  phase_day: 'Prep',
  phase_evening: 'Open',
  phase_night: 'Closed',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}s',
  phase_day_hint: 'Prepare your haunted house! Repair, assign ghosts, upgrade rooms.',
  phase_evening_hint: 'Business hours! Visitors are coming.',
  open_now_btn: 'OPEN NOW',
  speed_btn: 'x{n}',
  day_auto_open_hint: 'Evening has arrived! Time to open.',
  evening_ending_hint: 'Closing time! Wrapping up...',
  floor1_blocked_warning: 'Entry blocked! Repair Floor 1!',

  // === Ghost Staff ===
  gstaff_title: 'Ghost Staff',
  gstaff_repairman: 'Fix-It Phantom',
  gstaff_repairman_desc: 'A ghostly handyman who phases through walls to fix rooms',
  gstaff_repairman_effect: 'Auto-repair lowest condition room',
  gstaff_janitor: 'Dust Specter',
  gstaff_janitor_desc: 'Sweeps rooms clean with spectral energy',
  gstaff_janitor_effect: 'Auto-clean lowest hygiene room',
  gstaff_promoter: 'Howl Herald',
  gstaff_promoter_desc: 'Lures visitors with eerie whispers',
  gstaff_promoter_effect: '+20% visitor rate per level',
  gstaff_medic: 'Soul Soother',
  gstaff_medic_desc: 'Calms panicked visitors with ghostly charm',
  gstaff_medic_effect: 'Fled visitors leave neutral reviews',
  gstaff_security: 'Shadow Guard',
  gstaff_security_desc: 'Keeps order with an intimidating presence',
  gstaff_security_effect: '+10% satisfaction per level',
  gstaff_hire_cost: 'Summon: {sp} SP',
  gstaff_salary: 'Upkeep: {sp} SP/day',
  gstaff_fire: 'Banish',
  gstaff_fire_confirm: 'Banish this ghost staff?',
  gstaff_level: 'Lv.{n}',
  gstaff_none: 'No ghost staff summoned.',

  // === Day Summary Salary ===
  day_summary_salaries: 'Staff Salaries',
  day_summary_net_earnings: 'Net Earnings',
  day_summary_reviews_title: 'VISITOR REVIEWS',
  day_summary_avg_stars: 'AVG RATING',
  day_summary_fame_change: 'FAME',
  day_summary_no_reviews: 'No reviews today',
  day_summary_review_visitor: 'Visitor #{n}',
  day_summary_highlight: 'HIGHLIGHT',

  // === Tutorial ===
  tutorial_welcome_title: 'Welcome, Boss!',
  tutorial_welcome_body: 'The ghosts are hungry and jobless! Help them run a haunted house business.',
  tutorial_welcome_btn: 'Let\'s Go!',
  tutorial_build_title: 'Build a Room',
  tutorial_build_body: 'Tap an empty floor to build a spooky room. Your ghosts need a workplace!',
  tutorial_ghost_title: 'Assign a Ghost',
  tutorial_ghost_body: 'Tap a room and assign a ghost. They\'ll do their best to spook visitors!',
  tutorial_open_title: 'Open for Business!',
  tutorial_open_body: 'Tap the "Ready" button to open your haunted house and welcome visitors.',
  tutorial_facility_intro_title: 'Facility Area',
  tutorial_facility_intro_body: 'Your park has a street with facility plots! Build shops and attractions to earn more.',
  tutorial_facility_build_title: 'Build a Facility',
  tutorial_facility_build_body: 'Tap an empty plot and choose a facility to build. Try a Gift Shop or Snack Bar!',
  tutorial_facility_staff_title: 'Assign Staff',
  tutorial_facility_staff_body: 'Assign a ghost to your new facility. Staffed facilities earn 20% more revenue!',
  tutorial_facility_open_title: 'Open Facility',
  tutorial_facility_open_body: 'Open your facility so visitors can use it. You can set prices too!',
  tutorial_done_title: 'You\'re All Set!',
  tutorial_done_body: 'Visitors will come, get spooked, and pay you. Upgrade rooms and hire more ghosts to grow your business!',
  tutorial_skip: 'Skip Tutorial',
  tutorial_next: 'Next',
  tutorial_got_it: 'Got It!',

  // === Story Arc System ===
  story_intro: 'Intro',
  story_rising: 'Rising',
  story_climax: 'Climax',
  story_resolution: 'Resolution',
  story_grade: 'Story Arc: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: 'Story Arc System Unlocked!',
  story_guide_desc: 'With 4+ rooms, arrange your floors to create a story arc for bonus SP!',
  story_role_label: '{role}',
  story_intro_desc: 'Build atmosphere: high atmosphere, low fear',
  story_rising_desc: 'Ramp up tension: increase fear and thrill',
  story_climax_desc: 'Peak terror: maximum fear and thrill',
  story_resolution_desc: 'Release and fun: boost fun stat',
  story_room_role: 'Story Role: {role}',
  story_none: 'None',

  // === Room Available Props ===
  room_available_props: 'Installable: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: 'Waiting: {n}/{max}',
  lq_avg_patience: 'Avg. Patience: {n}%',
  lq_queue_empty: 'No visitors in queue',

  // === Lobby Facilities ===
  lf_title: 'Lobby Facilities',
  lf_patience_bonus: 'Patience -{n}%',
  lf_revenue_bonus: '+{n} SP/visitor',
  lf_npc_bonus: 'NPC Staff: +15% patience, +20% revenue',
  lf_npc_staff: 'NPC Staff',

  lf_ticket_booth: 'Ticket Booth',
  lf_ticket_booth_desc: 'Essential ticket processing counter',
  lf_waiting_lounge: 'Waiting Lounge',
  lf_waiting_lounge_desc: 'Comfortable waiting area with seating (+patience)',
  lf_vip_lounge: 'VIP Lounge',
  lf_vip_lounge_desc: 'Premium lounge for VIP visitors',
  lf_reservation_center: 'Reservation Center',
  lf_reservation_center_desc: 'Pre-booking system for visitors (+patience)',
  lf_poster_wall: 'Poster Wall',
  lf_poster_wall_desc: 'Spooky posters build anticipation (+patience)',
  lf_snack_cart: 'Snack Cart',
  lf_snack_cart_desc: 'Snacks keep visitors happy and patient',
  lf_souvenir_booth: 'Souvenir Booth',
  lf_souvenir_booth_desc: 'Sell souvenirs for extra revenue',
  lf_photo_zone: 'Photo Zone',
  lf_photo_zone_desc: 'Visitors take photos, boosting fame and revenue',
  lf_tv_monitor: 'TV Monitor',
  lf_tv_monitor_desc: 'Scare highlights keep visitors entertained',
  lf_costume_rental: 'Costume Rental',
  lf_costume_rental_desc: 'Visitors rent costumes for extra fun and revenue',
  lf_fortune_booth: 'Fortune Booth',
  lf_fortune_booth_desc: 'Mysterious fortune-telling builds atmosphere',
  lf_built_badge: 'Built',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: 'Ticket Speed: -15% entry interval per level',
  lf_ue_max_queue_up: 'Capacity: +5 max queue size per level',
  lf_ue_vip_rate_up: 'VIP Rate: x2 VIP visitor appearance per level',
  lf_ue_satisfaction_up: 'Anticipation: +20% base satisfaction',
  lf_ue_emergency_patience: 'Emergency Snack: +15 patience for low visitors',
  lf_ue_revisit_rate_up: 'Souvenirs: +15% next-day visitor bonus',
  lf_ue_reputation_per_day: 'SNS Shares: +2 reputation per day per level',
  lf_ue_anticipation_up: 'Horror Preview: +40% excitement boost',
  lf_ue_fun_bonus: 'Costumes: +15 fun stat per level',
  lf_ue_random_sp_bonus: 'Fortune: +10% random bonus SP chance',
  ticket_price_setting: 'Ticket Price',

  // === Lobby Facility Props ===
  lobby_prop_candle: 'Candle',
  lobby_prop_candle_desc: 'A flickering candle for atmosphere',
  lobby_prop_cobweb: 'Cobweb',
  lobby_prop_cobweb_desc: 'Spooky cobwebs draped around',
  lobby_prop_pumpkin: 'Pumpkin',
  lobby_prop_pumpkin_desc: 'Classic carved pumpkin lantern',
  lobby_prop_magazine_rack: 'Magazine Rack',
  lobby_prop_magazine_rack_desc: 'Spooky magazines for waiting visitors',
  lobby_prop_chandelier: 'Chandelier',
  lobby_prop_chandelier_desc: 'Elegant gothic chandelier',
  lobby_prop_wine_glass: 'Wine Glass',
  lobby_prop_wine_glass_desc: 'Crystal wine glasses for VIP ambiance',
  lobby_prop_velvet_curtain: 'Velvet Curtain',
  lobby_prop_velvet_curtain_desc: 'Rich velvet drapes for luxury feel',
  lobby_prop_gold_frame: 'Gold Frame',
  lobby_prop_gold_frame_desc: 'Ornate gold picture frame',
  lobby_prop_picture_frame: 'Picture Frame',
  lobby_prop_picture_frame_desc: 'Haunted portrait on the wall',
  lobby_prop_spotlight: 'Spotlight',
  lobby_prop_spotlight_desc: 'Dramatic lighting for displays',
  lobby_prop_skull_ornament: 'Skull Ornament',
  lobby_prop_skull_ornament_desc: 'Decorative skull for spooky vibes',
  lobby_prop_pumpkin_cookie: 'Pumpkin Cookie',
  lobby_prop_pumpkin_cookie_desc: 'Tasty pumpkin-shaped cookies',
  lobby_prop_ghost_drink: 'Ghost Drink',
  lobby_prop_ghost_drink_desc: 'Mysterious glowing beverage',
  lobby_prop_napkin_holder: 'Napkin Holder',
  lobby_prop_napkin_holder_desc: 'Keeps the snack area tidy',
  lobby_prop_display_shelf: 'Display Shelf',
  lobby_prop_display_shelf_desc: 'Showcase souvenirs attractively',
  lobby_prop_plush_doll: 'Plush Doll',
  lobby_prop_plush_doll_desc: 'Cute ghost plush toy',
  lobby_prop_keychain_rack: 'Keychain Rack',
  lobby_prop_keychain_rack_desc: 'Spinning rack of spooky keychains',
  lobby_prop_wrapping_paper: 'Wrapping Paper',
  lobby_prop_wrapping_paper_desc: 'Halloween-themed gift wrap',
  lobby_prop_backdrop: 'Backdrop',
  lobby_prop_backdrop_desc: 'Themed photo background',
  lobby_prop_prop_box: 'Prop Box',
  lobby_prop_prop_box_desc: 'Box of fun photo accessories',
  lobby_prop_mask_stand: 'Mask Stand',
  lobby_prop_mask_stand_desc: 'Display of creepy masks for photos',
  lobby_prop_antenna: 'Antenna',
  lobby_prop_antenna_desc: 'TV signal receiver',
  lobby_prop_remote_control: 'Remote Control',
  lobby_prop_remote_control_desc: 'Control the TV channels',
  lobby_prop_speaker: 'Speaker',
  lobby_prop_speaker_desc: 'Surround sound for the horror reel',
  lobby_prop_cable_wires: 'Cable Wires',
  lobby_prop_cable_wires_desc: 'Tangled wires add to the eerie feel',
  lobby_prop_clothes_rack: 'Clothes Rack',
  lobby_prop_clothes_rack_desc: 'Rack of spooky costumes',
  lobby_prop_mirror: 'Mirror',
  lobby_prop_mirror_desc: 'Full-length mirror for costume check',
  lobby_prop_makeup_table: 'Makeup Table',
  lobby_prop_makeup_table_desc: 'Apply spooky makeup here',
  lobby_prop_wig_stand: 'Wig Stand',
  lobby_prop_wig_stand_desc: 'Collection of creepy wigs',
  lobby_prop_crystal_ball: 'Crystal Ball',
  lobby_prop_crystal_ball_desc: 'See your spooky future',
  lobby_prop_tarot_cards: 'Tarot Cards',
  lobby_prop_tarot_cards_desc: 'Mysterious fortune-telling cards',
  lobby_prop_curtain: 'Curtain',
  lobby_prop_curtain_desc: 'Mystical curtain for the fortune booth',
  lobby_prop_candelabra: 'Candelabra',
  lobby_prop_candelabra_desc: 'Multi-armed candle holder for ambiance',

  // === Lobby NPC Ghost ===
  lnpc_title: 'Lobby Ghost Patrol',
  lnpc_assign: 'Assign Ghost',
  lnpc_unassign: 'Remove',
  lnpc_desc: 'Ghosts scare waiting visitors, boosting patience',
  lnpc_slot: '{cur}/{max} Ghosts',

  // === Random Event System ===
  evt_time_remaining: '{sec}s remaining',

  // Tier 1 Events
  evt_rain_name: 'Sudden Rain',
  evt_rain_desc: 'Heavy rain falls suddenly. Visitors without umbrellas are leaving the queue.',
  evt_rain_c1: 'Ignore',
  evt_rain_c2: 'Hand out umbrellas (100 SP)',
  evt_rain_r1: '3 visitors left the queue in the rain.',
  evt_rain_r2: 'Umbrellas were handed out. Everyone stays dry.',

  evt_couple_fight_name: 'Couple Fight',
  evt_couple_fight_desc: 'A couple starts arguing loudly in the queue, disturbing others.',
  evt_couple_fight_c1: 'Handle it',
  evt_couple_fight_r1: 'The situation has been dealt with.',

  evt_crying_child_name: 'Crying Child',
  evt_crying_child_desc: 'A child starts crying in the queue, making others uneasy.',
  evt_crying_child_c1: 'Give candy (50 SP)',
  evt_crying_child_c2: 'Ignore',
  evt_crying_child_r1: 'The candy cheered the child up.',
  evt_crying_child_r2: 'The crying continued, testing everyone\'s patience.',

  evt_blackout_name: 'Power Outage',
  evt_blackout_desc: 'A sudden power outage plunges everything into darkness.',
  evt_blackout_c1: 'Start generator (200 SP)',
  evt_blackout_c2: 'Wait it out',
  evt_blackout_r1: 'The generator kicked in. Business continues.',
  evt_blackout_r2: 'Everyone waited in the dark for a while.',

  evt_line_cutter_name: 'Line Cutter',
  evt_line_cutter_desc: 'Someone brazenly cuts into the front of the queue.',
  evt_line_cutter_c1: 'Call security',
  evt_line_cutter_c2: 'Ignore',
  evt_line_cutter_r1: 'Security escorted the line cutter out.',
  evt_line_cutter_r2: 'Others in line grumble in frustration.',

  evt_fake_ghost_name: 'Fake Ghost Prank',
  evt_fake_ghost_desc: 'A visitor dressed as a ghost is scaring others in line. The crowd seems amused.',
  evt_fake_ghost_c1: 'Let them have fun',
  evt_fake_ghost_r1: 'The prank added to the spooky atmosphere. Reputation up!',

  evt_lost_item_name: 'Lost Item Report',
  evt_lost_item_desc: 'A visitor reports a lost item near the entrance.',
  evt_lost_item_c1: 'Help find it (Reputation +5)',
  evt_lost_item_c2: 'Ignore',
  evt_lost_item_r1: 'The lost item was found! The visitor is grateful.',
  evt_lost_item_r2: 'The visitor left disappointed.',

  evt_snack_sold_out_name: 'Snacks Sold Out',
  evt_snack_sold_out_desc: 'The snack cart ran out of stock. Visitors are asking for snacks.',
  evt_snack_sold_out_c1: 'Emergency restock (100 SP)',
  evt_snack_sold_out_c2: 'Wait for next shipment',
  evt_snack_sold_out_r1: 'Snacks are back in stock.',
  evt_snack_sold_out_r2: 'Visitors will have to wait.',

  evt_sns_selfie_name: 'SNS Photo Op',
  evt_sns_selfie_desc: 'A visitor wants to take a selfie for social media.',
  evt_sns_selfie_c1: 'Acknowledge',
  evt_sns_selfie_r1: 'The post boosted your online presence.',

  evt_hot_weather_name: 'Scorching Heat',
  evt_hot_weather_desc: 'The temperature soars. Visitors look uncomfortable in the heat.',
  evt_hot_weather_c1: 'Free drinks (150 SP)',
  evt_hot_weather_c2: 'Endure it',
  evt_hot_weather_r1: 'Cool drinks refreshed everyone.',
  evt_hot_weather_r2: 'The heat is taking a toll on patience.',

  // Tier 2 Events
  evt_tour_bus_name: 'Tour Bus Arrival',
  evt_tour_bus_desc: 'A tour bus just arrived! A large group of tourists floods the entrance.',
  evt_tour_bus_c1: 'Welcome them',
  evt_tour_bus_r1: 'The queue fills up with excited tourists.',

  evt_tv_coverage_name: 'TV Crew Request',
  evt_tv_coverage_desc: 'A local TV station wants to cover your haunted house.',
  evt_tv_coverage_c1: 'Accept (risky)',
  evt_tv_coverage_c2: 'Decline',
  evt_tv_coverage_r1: 'The coverage aired. Results vary...',
  evt_tv_coverage_r2: 'You politely declined the offer.',

  evt_spy_name: 'Rival Spy',
  evt_spy_desc: 'You spot someone suspiciously taking notes about your operations.',
  evt_spy_c1: 'Apprehend (need security)',
  evt_spy_c2: 'Ignore',
  evt_spy_r1: 'The spy was caught. You recovered valuable intel.',
  evt_spy_r2: 'Some of your ideas might leak to competitors.',

  evt_health_inspection_name: 'Health Inspection',
  evt_health_inspection_desc: 'Health inspectors arrive for a surprise visit.',
  evt_health_inspection_c1: 'Open the doors',
  evt_health_inspection_r1: 'The inspection is complete.',

  evt_halloween_season_name: 'Halloween Fever',
  evt_halloween_season_desc: 'Halloween spirit fills the air! Everyone is in the mood for scares.',
  evt_halloween_season_c1: 'Celebrate!',
  evt_halloween_season_r1: 'Halloween boost! Extra visitors and SP incoming.',

  evt_ghost_strike_name: 'Ghost Strike',
  evt_ghost_strike_desc: 'Overworked ghosts are refusing to scare. They demand better conditions.',
  evt_ghost_strike_c1: 'Pay bonus (500 SP)',
  evt_ghost_strike_c2: 'Wait it out',
  evt_ghost_strike_r1: 'The bonus satisfied the ghosts. Back to work!',
  evt_ghost_strike_r2: 'The strike continues for a while...',

  evt_mystery_visitor_name: 'Mystery Critic',
  evt_mystery_visitor_desc: 'A famous horror critic is visiting in disguise. Results depend on your reputation.',
  evt_mystery_visitor_c1: 'Best behavior',
  evt_mystery_visitor_r1: 'The critic revealed themselves and wrote a review.',

  evt_maintenance_accident_name: 'Equipment Malfunction',
  evt_maintenance_accident_desc: 'A piece of equipment malfunctioned in one of the rooms!',
  evt_maintenance_accident_c1: 'Assess damage',
  evt_maintenance_accident_r1: 'A room sustained damage. Repairs needed.',

  evt_sns_viral_name: 'Viral Video',
  evt_sns_viral_desc: 'A visitor\'s video of your haunted house went viral online!',
  evt_sns_viral_c1: 'Ride the wave',
  evt_sns_viral_r1: 'Your fame skyrockets! Reputation and SP boosted.',

  evt_total_blackout_name: 'Total Blackout',
  evt_total_blackout_desc: 'All power goes out across the entire area. Complete darkness.',
  evt_total_blackout_c1: 'Candlelight event (+Rep)',
  evt_total_blackout_c2: 'Wait for power',
  evt_total_blackout_r1: 'The candlelight atmosphere was a hit!',
  evt_total_blackout_r2: 'Everyone waited in the dark.',

  // Tier 3 Events
  evt_famous_youtuber_name: 'Famous Streamer',
  evt_famous_youtuber_desc: 'A famous horror streamer with millions of followers is live-streaming from your haunted house!',
  evt_famous_youtuber_c1: 'Give VIP treatment',
  evt_famous_youtuber_r1: 'The stream was a massive hit! Reputation +30, SP +2000.',

  evt_celeb_visit_name: 'Celebrity Visit',
  evt_celeb_visit_desc: 'A major celebrity has arrived for a private scare session!',
  evt_celeb_visit_c1: 'Roll out the red carpet',
  evt_celeb_visit_r1: 'The celebrity loved it! Huge publicity boost.',

  evt_franchise_offer_name: 'Franchise Offer',
  evt_franchise_offer_desc: 'A corporation wants to franchise your haunted house brand.',
  evt_franchise_offer_c1: 'Accept (10000 SP)',
  evt_franchise_offer_c2: 'Decline',
  evt_franchise_offer_r1: 'Deal signed! A hefty payment arrives.',
  evt_franchise_offer_r2: 'You prefer to stay independent.',

  evt_intl_contest_name: 'International Horror Contest',
  evt_intl_contest_desc: 'Your haunted house is invited to an international scare competition!',
  evt_intl_contest_c1: 'Enter the contest',
  evt_intl_contest_r1: 'You earned recognition on the world stage!',

  evt_documentary_name: 'Documentary Filming',
  evt_documentary_desc: 'A documentary crew wants to film the story of your haunted house.',
  evt_documentary_c1: 'Allow filming',
  evt_documentary_r1: 'The documentary premieres to rave reviews!',

  evt_ghost_king_name: 'The Ghost King Appears',
  evt_ghost_king_desc: 'A legendary ghost is drawn to your haunted house by its fame.',
  evt_ghost_king_c1: 'Welcome the Ghost King',
  evt_ghost_king_r1: 'The Ghost King joins your ranks! Morale soars.',

  evt_gov_subsidy_name: 'Government Grant',
  evt_gov_subsidy_desc: 'The tourism board awards your haunted house a cultural preservation grant.',
  evt_gov_subsidy_c1: 'Accept the grant',
  evt_gov_subsidy_r1: 'Grant received: 5000 SP!',

  evt_vip_party_name: 'VIP Party Request',
  evt_vip_party_desc: 'A wealthy patron wants to rent the entire haunted house for a private party.',
  evt_vip_party_c1: 'Accept (8000 SP)',
  evt_vip_party_c2: 'Decline',
  evt_vip_party_r1: 'The VIP party was a huge success!',
  evt_vip_party_r2: 'You keep the doors open for regular visitors.',

  evt_horror_festival_name: 'Horror Festival',
  evt_horror_festival_desc: 'The city is hosting a horror festival and your haunted house is the main attraction!',
  evt_horror_festival_c1: 'Lead the festival',
  evt_horror_festival_r1: 'The festival was legendary! Massive rewards earned.',

  evt_legendary_review_name: 'Legendary Review',
  evt_legendary_review_desc: 'The world\'s most famous horror critic publishes a glowing review of your haunted house.',
  evt_legendary_review_c1: 'Bask in glory',
  evt_legendary_review_r1: 'A flood of 5-star reviews and fame follows!',

  // === Event Defense System ===
  evt_defense_badge: 'Auto-Resolved!',
  evt_defense_bonus: 'Bonus: +{sp} SP',

  // Tier 1 Defense
  evt_rain_defense: 'The roof upgrade keeps everyone dry. No one leaves!',
  evt_rain_hint: 'Tip: Upgrade Poster Wall to Lv.3 to auto-defend against rain.',
  evt_couple_fight_defense: 'Security steps in and mediates the situation calmly.',
  evt_couple_fight_hint: 'Tip: Hire a Security guard to auto-resolve fights.',
  evt_crying_child_defense: 'The snack cart attendant offers candy. The child smiles!',
  evt_crying_child_hint: 'Tip: Build a Snack Cart to automatically comfort crying children.',
  evt_blackout_defense: 'Emergency generators kick in automatically. No interruption!',
  evt_blackout_hint: 'Tip: Upgrade facilities to total Lv.10+ for backup power.',
  evt_line_cutter_defense: 'Security handles the line cutter immediately. Order restored!',
  evt_line_cutter_hint: 'Tip: Hire a Security guard to auto-handle line cutters.',
  evt_fake_ghost_defense: 'Your real NPC ghosts outshine the impostor. Excitement rises!',
  evt_fake_ghost_hint: 'Tip: Assign at least 1 NPC ghost to the lobby to overshadow fakers.',
  evt_lost_item_defense: 'Your staff quickly locates and returns the lost item!',
  evt_lost_item_hint: 'Tip: Hire 3+ staff members to auto-find lost items.',
  evt_snack_sold_out_defense: 'Inventory auto-restocked from reserves. Sales continue!',
  evt_snack_sold_out_hint: 'Tip: Upgrade Snack Cart to Lv.2+ for auto-restocking.',
  evt_sns_selfie_defense: 'Photo Zone provides the perfect backdrop. Great shots posted!',
  evt_sns_selfie_hint: 'Tip: Build a Photo Zone for automatic photo opportunities.',
  evt_hot_weather_defense: 'The monitor area has air conditioning. Everyone stays cool!',
  evt_hot_weather_hint: 'Tip: Install a TV Monitor to provide a cooled waiting area.',

  // Tier 2 Defense
  evt_tour_bus_defense: 'Plenty of room! All tourists are welcomed in.',
  evt_tour_bus_hint: 'Tip: Expand queue capacity to 15+ to accept large groups.',
  evt_tv_coverage_defense: 'With great reputation and many ghosts, the broadcast is a hit!',
  evt_tv_coverage_hint: 'Tip: Reach reputation 50+ and hire 5+ ghosts for guaranteed success.',
  evt_spy_defense: 'Security catches the spy red-handed! Intel recovered.',
  evt_spy_hint: 'Tip: Hire a Security guard to auto-detect spies.',
  evt_health_inspection_defense: 'Spotless! The inspector awards a hygiene certificate.',
  evt_health_inspection_hint: 'Tip: Hire a Janitor and keep average hygiene above 70.',
  evt_ghost_strike_defense: 'Ghosts are well-rested and happy. No strike today!',
  evt_ghost_strike_hint: 'Tip: Keep average ghost fatigue below 30 to prevent strikes.',
  evt_mystery_visitor_defense: 'Your excellent reputation earns a glowing review!',
  evt_mystery_visitor_hint: 'Tip: Maintain reputation at 60+ for guaranteed good reviews.',
  evt_maintenance_accident_defense: 'The repairman fixes it on the spot. Minimal damage!',
  evt_maintenance_accident_hint: 'Tip: Hire a Repairman to minimize equipment damage.',
  evt_total_blackout_defense: 'Repairman restores power instantly. Candle event bonus!',
  evt_total_blackout_hint: 'Tip: Hire a Repairman and reach facility Lv.15+ total.',

  // Tier 3 Defense
  evt_vip_party_defense: 'Costumes and photo zone make the party unforgettable! Normal business continues too.',
  evt_vip_party_hint: 'Tip: Build Costume Rental and Photo Zone for the ultimate party.',
  room_repair_needed: 'Repair Needed',
  room_repairing: 'Repairing...',
  room_cleaning: 'Cleaning...',

  // === World Street ===
  world_title: 'Buildings',
  world_subtitle: 'Select a building to manage',
  world_empty_plot: 'Empty Plot',
  world_build_new: 'Build a new themed haunted house',
  rename_building: 'Rename Building',
  rename_building_desc: 'Enter a new name for this building.',
  rename: 'Rename',
  building_renamed: 'Building renamed!',

  // === Construction Popup ===
  construction_title: 'New Building',
  construction_subtitle: 'Build a new haunted house to manage!',
  construction_name_label: 'Building Name',
  construction_name_placeholder: 'e.g., Midnight Manor',
  construction_theme_label: 'Theme',
  construction_start: 'Build',
  world_status_build: 'Build',
  world_status_open: 'Open',
  world_status_ready: 'Ready',
  theme_haunted_house: 'Haunted House',
  theme_haunted_house_desc: 'Classic spooky funhouse experience',
  theme_abandoned_hospital: 'Abandoned Hospital',
  theme_abandoned_hospital_desc: 'Medical horror and lab atmosphere',
  theme_school_back_mountain: 'School Back Mountain',
  theme_school_back_mountain_desc: 'School ghost stories and mountain trails',
  theme_cursed_circus: 'Cursed Circus',
  theme_cursed_circus_desc: 'A cursed circus tent of bizarre horrors',
  theme_ancient_temple: 'Ancient Temple',
  theme_ancient_temple_desc: 'Mystical curses of an ancient temple',
  theme_pirate_ship: 'Pirate Ship',
  theme_pirate_ship_desc: 'Sea horror of a cursed pirate ship',
  theme_abandoned_mine: 'Abandoned Mine',
  theme_abandoned_mine_desc: 'Deep dark horrors of an abandoned mine',
  theme_gothic_castle: 'Gothic Castle',
  theme_gothic_castle_desc: 'Elegant and eerie aristocratic horror',
  theme_underground_bunker: 'Underground Bunker',
  theme_underground_bunker_desc: 'Experiments and conspiracies underground',
  theme_cursed_forest: 'Cursed Forest',
  theme_cursed_forest_desc: 'Nature spirits and primal horror',
} as const;

export default en;
export type TranslationKey = keyof typeof en;
export type Translations = Record<TranslationKey, string>;
